<template>
  <div>
    <!-- Email Input -->
    <div :style="showInputCheckEmail ? 'display:none;' : 'display:flex;'" class="col form-group">
      <input
        id="email"
        v-model="obj.email"
        class="w-100"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        :placeholder="placeholders.email"
      />
    </div>

    <!-- Confirm Email Input -->
    <div
      :style="showInputCheckEmail ? 'display:none;' : 'display:flex;'"
      class="col form-group mt-5"
    >
      <input
        id="emailConfirmation"
        v-model="obj.emailConfirmation"
        class="w-100"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        :placeholder="placeholders.confirmEmail"
        @keyup.enter="validateFields"
        @paste="blockPaste"
      />
    </div>

    <!-- Send Confirm Code Email Input -->
    <p
      :style="
        showInputCheckEmail && !template.secondaryTheme
          ? 'display:block; font-size:0.85rem; margin-left: 16px;'
          : showInputCheckEmail && template.secondaryTheme
          ? 'color: white !important; display:block; font-size:0.85rem; margin-left: 16px;'
          : ' display:none;'
      "
    >
      {{
        obj.passport
          ? 'A code has been sent to your email!'
          : 'Um código foi enviado no seu e-mail!'
      }}
    </p>

    <div :style="showInputCheckEmail ? 'display:block;' : 'display:none;'" class="col form-group">
      <input
        id="emailConfirmation"
        v-model="codeToSend"
        class="w-100"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        :placeholder="placeholders.verificationCode"
        @keyup.enter="validateFields"
        @paste="blockPaste"
      />
      <p
        :style="
          template.secondaryTheme
            ? 'font-size:0.8rem; color: ${primaryColor}; text-align: left; color: white;'
            : `font-size:0.8rem; color: ${primaryColor}; text-align: left;`
        "
        class="mt-3 mr-4"
      >
        {{ mandatoryText }}
      </p>
    </div>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'
import store from '@/store/store.js'
import { loginFB } from '../../services/ServFB.js'

const lFB = new loginFB()

export default {
  name: 'EmailWithConfirmation',
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
    showInputCheckEmail: false,
    codeToSend: '',
    toastMessage: '',
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template']),
    primaryColor() {
      return store.state.template.primaryColor
    },
    mandatoryText() {
      let text =
        store.state.config.mandatoryCheck == true
          ? this.obj.passport
            ? '*Mandatory'
            : '*Obrigatório'
          : this.obj.passport
          ? '*Not mandatory'
          : '*Não obrigatório'
      return text
    },
    mandatoryCheck() {
      let isMandatory = store.state.config.mandatoryCheck == true ? true : false
      return isMandatory
    },
    placeholders() {
      if (this.obj.passport) {
        return {
          email: 'Email',
          confirmEmail: 'Confirm your email',
          verificationCode: 'Enter verification code',
        }
      }
      return {
        email: 'E-mail',
        confirmEmail: 'Confirme seu E-mail',
        verificationCode: 'Insira o código de verificação',
      }
    },
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  mounted() {
    // Create a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))
    document.getElementById('email').focus()
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    /* Helpers */
    blockPaste() {
      return false
    },
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: this.obj.passport ? 'Attention' : 'Atenção',
        variant: variant,
        solid: true,
      })
    },
    /* Validations */
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      if (!this.checkEmail(this.obj.email)) {
        const warningMsg = this.obj.passport
          ? 'A valid email is required.'
          : 'É necessário um Email válido.'
        this.addRegistrationError({
          msg: warningMsg,
        })
        this.toastMessage = warningMsg
        this.makeToast('warning')

        hasErrors = true
      }

      if (this.obj.email !== this.obj.emailConfirmation) {
        const warningMsg = this.obj.passport
          ? 'The emails provided are different.'
          : 'Os emails informados são diferentes.'
        this.addRegistrationError({
          msg: warningMsg,
        })
        this.toastMessage = warningMsg
        this.makeToast('warning')

        hasErrors = true
      }

      if (this.showInputCheckEmail == true) {
        if (this.codeToSend.length < 5 && store.state.config.mandatoryCheck == true) {
          const warningMsg = this.obj.passport
            ? 'Incomplete code provided.'
            : 'Código informado incompleto.'
          this.addRegistrationError({
            msg: warningMsg,
          })
          this.toastMessage = warningMsg
          this.makeToast('warning')
          hasErrors = true
        }
      }

      if (!hasErrors && this.showInputCheckEmail == true) {
        let code = this.codeToSend
        if (code.length > 5 && store.state.config.mandatoryCheck == true) {
          this.checkEmailCodeToConfirmService(this.codeToSend, this.obj.email)
        } else {
          if (code.length >= 0) {
            this.checkEmailCodeToConfirmService(this.codeToSend, this.obj.email)
          } else {
            this.$store.commit('updateRegistrationObject', this.obj)
            this.$emit('next')
          }
        }
      }

      if (!hasErrors && !this.showInputCheckEmail) {
        this.checkExistingEmail(this.obj.cpf || null, this.obj.email)
      }
    },
    //enviar e-mail para salvar no banco o code
    async sendEmailCodeToConfirmService(email) {
      try {
        const owner = store.state.config.ownerId
        const name = store.state.config.name
        await lFB.sendEmailCodeToConfirm(email, owner, name)
      } catch (err) {
        this.toastMessage = err
        this.makeToast('danger')
      }
    },
    //consultar no banco para ver se o code está correto
    async checkEmailCodeToConfirmService(code, email) {
      try {
        const name = store.state.config.name
        await lFB.checkEmailCodeToConfirm(code, email, name).then(res => {
          let codesucess = res
          if (codesucess === 1) {
            this.obj.code = code
            this.$store.commit('updateRegistrationObject', this.obj)
            this.$emit('next')
          } else {
            const warningMsg = this.obj.passport
              ? 'Incorrect code entered.'
              : 'Código informado incorreto.'
            this.addRegistrationError({
              msg: warningMsg,
            })
            this.toastMessage = warningMsg
            this.makeToast('danger')
          }
        })
      } catch (err) {
        this.toastMessage = err
        this.makeToast('danger')
      }
    },
    checkEmail(email) {
      const emailRegex = /\S+@\S+\.\S+/
      return emailRegex.test(email)
    },
    async checkExistingEmail(cpf, email) {
      try {
        const response = await lFB.checkUserEmail(this.config.name, cpf, email, this.config.systemID, this.config.ownerId)
        if (response.header.codigo !== 1) {
          this.toastMessage = response.header.msg || 'Erro desconhecido ao verificar e-mail.'
          this.makeToast('warning')
          return
        }
        this.showInputCheckEmail = true
        this.sendEmailCodeToConfirmService(this.obj.email)
      } catch (err) {
        this.addRegistrationError({
          msg: err,
        })
        this.toastMessage = err
        this.makeToast('warning')
      }
    },
  },
}
</script>
